import React from 'react';
import styled from 'styled-components';
import { PageHeaderInfo } from '../../../shared/components';
import type { PaymentDetailResponse } from '../types';
import { StatusChip } from './StatusChip';
import { formatDetailDateTime, INK } from './styles';

/**
 * Detail header meta row (PRD §4d/§12): the `PageHeader` `info` content — status
 * chip + client + datetime under the amount title. Children are passed directly
 * to the DS `PageHeaderInfo`, which owns their spacing (mt 8px / mr 24px), so we
 * add none ourselves (mirrors lum-web's `TransactionHeader`). `clientName` /
 * `requestDate` come from the detail payload (O-1) and render only when present.
 */
const Client = styled.span`
  font:
    600 16px/24px Inter,
    sans-serif;
  color: ${INK};
`;

const DateTime = styled.span`
  font:
    400 16px/24px Inter,
    sans-serif;
  color: ${INK};
`;

export const DetailMeta: React.FC<{ payment: PaymentDetailResponse; locale: string }> = ({
  payment,
  locale,
}) => (
  <PageHeaderInfo>
    <StatusChip status={payment.paymentStatus} />
    {payment.clientName && <Client>{payment.clientName}</Client>}
    {payment.requestDate && (
      <DateTime>{formatDetailDateTime(payment.requestDate, locale)}</DateTime>
    )}
  </PageHeaderInfo>
);
